import * as Yup from "yup";

export function validationObject<T extends object>(object: {
  [K in keyof T]: Yup.Schema<T[K], Yup.AnyObject>;
}) {
  return Yup.object(object);
}
